(() => {
  function init(root) {
    if (!root || root.dataset.towaHomeReady) return;
    root.dataset.towaHomeReady = "true";
    // Keep the in-page shopping shortcut independent of theme/router handlers.
    root.addEventListener("click", (event) => {
      const link = event.target.closest('a[href="#towa-choose"]');
      if (!link) return;
      const target = root.querySelector("#towa-choose");
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      target.scrollIntoView({ behavior: "instant", block: "start" });
      target.focus({ preventScroll: true });
    });
    const video = root.querySelector(".th-hero__video");
    const button = root.querySelector(".th-video-toggle");
    if (!video || !button) return;
    // Keep native controls when JavaScript is unavailable. Do not download or
    // autoplay the movie for reduced-motion / data-saving visitors.
    video.controls = false;
    button.hidden = false;
    const update = () => {
      button.textContent = video.paused ? "動画を再生 ▷" : "動画を停止 Ⅱ";
      button.setAttribute(
        "aria-label",
        video.paused ? "切れ味の動画を再生" : "切れ味の動画を停止",
      );
    };
    video.addEventListener("play", update);
    video.addEventListener("pause", update);
    button.addEventListener("click", () => {
      if (video.paused)
        video.play().catch(() => {
          video.controls = true;
          update();
        });
      else video.pause();
    });
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (
      !motion.matches &&
      !navigator.connection?.saveData &&
      "IntersectionObserver" in window
    ) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            video.play().catch(update);
            observer.disconnect();
          }
        },
        { threshold: 0.25 },
      );
      observer.observe(video);
    }
    motion.addEventListener("change", (event) => {
      if (event.matches) video.pause();
    });
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) video.pause();
    });
    update();
  }
  document.querySelectorAll("[data-towa-home]").forEach(init);
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target.querySelector("[data-towa-home]")),
  );
})();
